export interface IProtocoloJustificativaDoMedico {
  justificativaOrigem?: ProtocoloJustificativaOrigemEnum;
  texto?: string;
  criadoEm?: Date;
}

export enum ProtocoloJustificativaOrigemEnum {
  pedidoInicial = 'PedidoInicial',
  fidelizacao = 'Fidelizacao'
}
